import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { getOutputJsonTaskStatus } from '../../redux/slices/outputJson';
import { AppDispatch } from '../../redux/store/appStore';

const POLLING_INTERVAL = 10000;

interface UsePollingOptions {
  status: string | undefined;
  taskId: string | undefined;
  message?: string;
  onSuccess?: () => void;
  onFailure?: () => void;
}

export const usePollingTaskStatus = ({
  status,
  taskId,
  message,
  onSuccess,
  onFailure,
}: UsePollingOptions) => {
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (status === 'PENDING' && taskId) {
      intervalRef.current = setInterval(() => {
        dispatch(getOutputJsonTaskStatus({ celery_task_id: taskId }));
      }, POLLING_INTERVAL);
    }

    if (status === 'SUCCESS' || status === 'FAILURE') {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      if (status === 'SUCCESS') {
        onSuccess?.();
      }
      if (status === 'FAILURE') {
        onFailure?.();
      }
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [status, taskId, dispatch]);
};
